module.exports = __webpack_public_path__ + "static/media/readLater-active.df5c950a.svg";